var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconActiveStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 87.5 83.9",
    style: {
      enableBackground: "new 0 0 87.5 83.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6761EA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,77.7H75V43.3h1.6c2.1,0,4-1,5.2-2.7c1.2-1.7,1.4-3.9,0.6-5.8l-4.5-11.3c-0.5-1.2-1.6-2-2.9-2h-6.2 c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h4.1l3.7,9.4h-4.8l-56.2,0c0,0,0,0,0,0s0,0,0,0h-4.7l3.7-9.4h4.1c1.7,0,3.1-1.4,3.1-3.1 s-1.4-3.1-3.1-3.1h-6.2c-1.3,0-2.4,0.8-2.9,2L5.1,34.7c-0.8,1.9-0.5,4.1,0.6,5.8c1.2,1.7,3.1,2.7,5.2,2.7h1.6v34.4H3.1 c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h81.2c1.7,0,3.1-1.4,3.1-3.1S86.1,77.7,84.4,77.7z M18.8,43.3h50v34.4h-6.2v-25 c0-1.7-1.4-3.1-3.1-3.1H28.1c-1.7,0-3.1,1.4-3.1,3.1v25h-6.2V43.3z M56.2,77.7h-25V55.8h25V77.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,1.6c-0.5-0.5-1.1-0.9-1.8-1.2C57.9,0.1,57.2,0,56.5,0c-0.7,0-1.4,0.1-2.1,0.4c-0.7,0.3-1.3,0.7-1.8,1.2 L41.7,12.5l-3.4-3.4c-0.5-0.5-1.1-0.9-1.8-1.2c-0.7-0.3-1.4-0.4-2.1-0.4c-0.7,0-1.4,0.1-2.1,0.4c-0.7,0.3-1.3,0.7-1.8,1.2 c-1,1-1.6,2.4-1.6,3.8c0,1.4,0.6,2.8,1.6,3.8l7.3,7.3c1,1,2.4,1.6,3.8,1.6c1.4,0,2.8-0.6,3.8-1.6L60.1,9.5c0.5-0.5,1-1.1,1.3-1.8 c0.3-0.7,0.5-1.4,0.5-2.1c0-0.7-0.1-1.5-0.4-2.2C61.3,2.8,60.9,2.1,60.3,1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveStore);
export default __webpack_public_path__ + "static/media/icon_active_store.a3e46945aa7153345543367ecb4963e6.svg";
export { ForwardRef as ReactComponent };